import { createSelector } from 'reselect';
import { buildColumn, COLUMN_TYPE } from '../../../common/support/utils';
import type { IColumn } from '../../../common/types/IColumn';
import type { ColumnOptions, GetColumnKeys, GetColumnOptions } from './createColumnsSelector.types';

export const getStandardEventColumns = (standardEventKeys: string[], options?: ColumnOptions): IColumn[] => {
  return standardEventKeys.map((key) => buildColumn({ type: COLUMN_TYPE.STANDARD_EVENT, key, ...options }));
};

export const createStandardEventColumnsSelector = (
  getStandardEventKeys: GetColumnKeys,
  getColumnOptions: GetColumnOptions = () => undefined
) => {
  return createSelector(getStandardEventKeys, getColumnOptions, getStandardEventColumns);
};
